import { createAction, props } from '@ngrx/store';

export const mapReset = createAction('[Map] Reset Map');

export const updateCurrentMapType = createAction(
  '[Map] Update Current Map Type',
  props<{ payload: { mapTypeId: google.maps.MapTypeId } }>()
);

export const updateAvailableMapTypeIds = createAction(
  '[Map] Update Available Map Type Ids',
  props<{ payload: { availableMapTypeIds: google.maps.MapTypeId[] } }>()
);

export const updateCenter = createAction(
  '[Map] Update Center',
  props<{ payload: { location: google.maps.LatLngLiteral } }>()
);

export const updateUserPosition = createAction(
  '[Map] Update User Position',
  props<{ payload: { location: google.maps.LatLngLiteral } }>()
);

export const centerOnUserPosition = createAction('[Map] Center On User Position');
